import React, {useState} from 'react';
import {Dialog, DialogContent, Stack, Typography} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';

import {
  closeClientsDialog,
  continueDialog,
} from '../../redux/slices/reportsDialogSlice';
import AurButton from '../common/aur-button/AurButton';
import {RootState} from '../../redux/store';
import {
  setDuplicateEmail,
  setSelectedClient,
} from '../../redux/slices/bulkUserFileNameSlice';
import ClientListDropdown from './ClientListDropdown';
import {t} from 'i18next';
import {setBulkUploadClientId} from '../../redux/slices/selectedClientSlice';
import {useNavigate} from 'react-router-dom';
import {useAnalytics} from '../../hooks/useAnalytics';
import {
  GA_CLICK_TYPES,
  GA_EVENT_NAMES,
  GA_REGIONS,
  GA_SUBPAGE_TYPE,
} from '../../constants/analyticsConstants';

interface ClientSelectionModalProps {
  firstDropDownData: any[];
}

const ClientSelectionModal: React.FC<ClientSelectionModalProps> = ({
  firstDropDownData,
}) => {
  const dispatch = useDispatch();
  const {trackGAEvent} = useAnalytics();
  const {isClientsOpen: isOpen} = useSelector(
    (state: RootState) => state.dialog
  );

  const [dropDownEntity, setDropDownEntity] = useState<any>({
    options: [],
    selectedOption: '',
  });
  
  const handleContinueClick = () => {
    dispatch(continueDialog());
    const selectedClient = dropDownEntity?.options?.find(
      (ele: any) => ele.id === dropDownEntity.selectedOption
    );
    dispatch(setSelectedClient(selectedClient?.display));

    dispatch(setBulkUploadClientId(selectedClient?.id));
    dispatch(closeClientsDialog());
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('gaTracking.users.continue'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.MODAL,
        action: t('gaTracking.users.selectClientOkAction'),
      },
      subPage: {
        subpage_name: t('gaTracking.users.selectClientModal'),
        subpage_type: GA_SUBPAGE_TYPE.MODAL,
      },
    });
  };
  const navigate = useNavigate();
  const handleCancelClick = () => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('gaTracking.users.cancel'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.MODAL,
        action: t('gaTracking.users.selectClientCancelAction'),
      },
      subPage: {
        subpage_name: t('gaTracking.users.selectClientModal'),
        subpage_type: GA_SUBPAGE_TYPE.MODAL,
      },
    });
    dispatch(closeClientsDialog());
    dispatch(setDuplicateEmail(false));
    navigate('/users');
  };

  return (
    <div className="bulkclient-selection-modal">
      <Dialog open={isOpen} PaperProps={{className: 'clients-dropdown-dialog'}}>
        <DialogContent
          style={{
            backgroundColor: '#0C1119',
            overflow: 'hidden',
          }}
          className="model-content"
        >
          <Typography className="typo-text headline3_size mainheader-name ">
            {t('common.bulkUploadModule.addTeamMembers')}
          </Typography>
          <Typography className="typo-text body2_size subheader-name">
            {t('common.bulkUploadModule.selectClient')}
          </Typography>
          <div className="dropdown-main-div">
            <ClientListDropdown
              buttonOrTextField={'button'}
              data={firstDropDownData}
              buttonLabel={t('common.bulkUploadModule.selectClientButtonLabel')}
              dropDownID="Client"
              idKey="clientId"
              displayKey="name"
              dropDownEntity={dropDownEntity}
              setDropDownEntity={setDropDownEntity}
              showSearchBox={true}
            />
          </div>
        </DialogContent>
        <DialogContent className="client-footer">
          <Stack
            direction="row"
            spacing={2}
            justifyContent="flex-end"
            height={72}
          >
            <AurButton
              onClick={handleCancelClick}
              type="exit"
              size="Medium"
              label={t('buttons.cancel')}
              classNames="selection-cancel-button"
            />

            {/* Custom next page button */}

            <AurButton
              onClick={handleContinueClick}
              type="continue"
              size="Medium"
              label={t('buttons.continue')}
              disabled={!dropDownEntity?.selectedOption}
              classNames="selection-continue-button"
            />
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ClientSelectionModal;
